import { all, call, fork, put, takeEvery } from "redux-saga/effects";

import {
  ADD_SERVICE,
  DELETE_SERVICE,
  EDIT_SERVICE,
  GET_ALL_PAGE_SERVICES,
  GET_SERVICE,
} from "./actionTypes";
import {
  getAllPageSectionsApi as getAllPageServicesApi,
  getSectionApi as getServiceApi,
  editSectionApi as editServiceApi,
  addSectionApi as addServiceApi,
  deleteSectionApi as deleteServiceApi,
  reorderSectionsApi as reorderServicesApi
} from "api/section";

import {

  deleteServiceFailure,
  deleteServiceSuccess,

  editServiceFailure,
  editServiceSuccess,

  addServiceFailure,
  addServiceSuccess,

  getServiceFailure,
  getServiceSuccess,

  getAllPageServicesFailure,
  getAllPageServicesSuccess,

} from "./actions";
import { toastErrorMessageNew } from "helpers/toaster/toastErrorMessageNew";
import { toast } from "react-toastify";

function* getAllPageServices({ payload }) {
  try {
    const { data } = yield call(getAllPageServicesApi, payload);
    yield put(getAllPageServicesSuccess(data));
  } catch (error) {
    toastErrorMessageNew({ error: error?.response?.data });

    yield put(getAllPageServicesFailure(error.response.data || error));
  }
}

function* getService({ payload }) {
  try {
    const { data } = yield call(getServiceApi, payload);
    yield put( getServiceSuccess(data));
  } catch (error) {
    toastErrorMessageNew({ error: error?.response?.data });

    yield put(getServiceFailure(error.response.data || error));
  }
}

function* addService({ payload }) {
  try {
    const { data , success } = yield call(addServiceApi, {
      data: payload.data,
      page: payload.page,
    });

     if(success){
    yield put(addServiceSuccess(data));
     payload.toast.success("تم اضافة الخدمة بنجاح");
    payload.navigate(`/${payload.page}`);
     }
  } catch (error) {
    toastErrorMessageNew({ error: error?.response?.data });

    yield put(addServiceFailure(error.response.data || error));
  }
}

function* editService({ payload }) {
  try {
    const { data  , success} = yield call(editServiceApi, {
      data: payload.data,
      slug: payload.slug,
      page: payload.page,
    });
    if(success){
      payload.toast.success("تم تحديث الخدمة بنجاح");
      const serviceAfterEdit = data.sections.find(
        (section) => section.slug === payload.slug
      );
        
      if (payload?.navigate) {
        payload.navigate(`/${payload.page}`);
      }
      yield put(editServiceSuccess(serviceAfterEdit));
    }
  } catch (error) {
    toastErrorMessageNew({ error: error?.response?.data });

    yield put(editServiceFailure(error.response.data || error));
  }
}

function* deleteService({ payload }) {
  try {
    yield call(deleteServiceApi, payload.data);
    toast.success("تم الحذف بنجاح");
    yield put(deleteServiceSuccess(payload.data));
  } catch (error) {
    toastErrorMessageNew({ error: error?.response?.data });

    yield put(deleteServiceFailure(error.response.data || error));
  }
}

export function* watchGetService() {
  yield takeEvery(GET_SERVICE, getService);
}

export function* watchAddService() {
  yield takeEvery(ADD_SERVICE, addService);
}

export function* watchEditService() {
  yield takeEvery(EDIT_SERVICE, editService);
}

export function* watchDeleteService() {
  yield takeEvery(DELETE_SERVICE, deleteService);
}

export function* watchGetAllPageServices() {
  yield takeEvery(GET_ALL_PAGE_SERVICES, getAllPageServices);
}

function* sectionSaga() {
  yield all([
    fork(watchGetService),
    fork(watchEditService),
    fork(watchGetAllPageServices),
    fork(watchAddService),
    fork(watchDeleteService),
  ]);
}

export default sectionSaga;
